import DeferredDrawerLink from '@/client/features/drawerlink/DeferredDrawerLink';
import BlockedLink from '@/client/features/blockedlink/BlockedLink';

import { malwareKitsEntityQuery } from '../services/malwareKits';
import { malwareKitsDrawer } from '../configs/malwareKits.drawer';
import { CATALOGS } from '@/constants/permissions';

interface MalwareKitsDrawerProps {
  id: number;
  name: string;
  amount?: number;
}

const MalwareKitsDrawer = ({ id, name, amount }: MalwareKitsDrawerProps) => {
  const url = `/catalogs/malwarekits/entity/${id}`;
  const displayName = amount ? `${name} (${amount})` : name;

  return (
    <BlockedLink id={id} name={displayName} modules={CATALOGS.malwarekits.modules}>
      <DeferredDrawerLink
        id={id}
        value={displayName}
        content={malwareKitsDrawer}
        query={malwareKitsEntityQuery(id)}
        link={url}
      />
    </BlockedLink>
  );
};

export default MalwareKitsDrawer;
